<!-- eslint-disable vue/multi-word-component-names -->
<script>
export default {
  props: {
    text: {
      default: '',
      required: true,
      type: String,
    },
    link: {
      default: false,
      required: false,
      type: Boolean,
    },
    to: {
      default: '',
      required: false,
      type: String,
    },
  },
};
</script>
<template>
  <div v-if="!link" class="toast-content">
    {{ text }}
  </div>
  <v-btn v-else-if="to && link" dark link text class="toast-content" :to="to">
    {{ text }}
  </v-btn>
  <v-btn v-else-if="!to && link" dark link text class="toast-content" @click="$emit('click')">
    {{ text }}
  </v-btn>
</template>
<style lang="scss" scoped>
.toast-content {
  font-family: 'Yekan-Bakh-Regular';
  margin-right: 0.5rem;
  font-size: 13px;
}
</style>
<style scoped>
>>>.v-btn__content {
  font-size: 13px !important;
}

.v-btn__content {
  font-size: 13px !important;
}

>>>.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 4px;
}

.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 4px;
}
</style>
